import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Logo from "../../assets/img/logo4.jpg"
import api from "../../services/api";

import Whatsapp from "../../assets/img/icon/whatsapp.png"

import Modal from "./modal"
class Index extends Component {


  state = { 
    configuracao:[]
  }
    




async componentDidMount() {


    const response = await api.post("/configuracao/show");
    this.setState({ configuracao: response.data
     });



  }



  render() {
    return (
      <React.Fragment>


  <div class="header-top">
 	


			<div class="container">

               
      <div class="email trocarcidade">
                   <Modal />
                  
      </div>

               <div class="email">
               <a href={"tel:"+this.state.configuracao.telefone} >
                  <i class="fa fa-phone"></i> {this.state.configuracao.telefone}  
                  </a>
                 
                </div>

                <a href="/user/login">
                <div class="email mobile">
               
               <i class="fas fa-landmark "> Portal Financeiro</i>
              
                 
                </div>
                </a>
               

               
                <span class="hiddenmobile">
                <div class="email">
                <a href="/user/login">
                  <i class="fab fa-whatsapp">
                    </i> (71) 98248-4094
                </a>
                
                </div>
                <div class="email">
                  <i class="fa fa-envelope-o">
                    </i> {this.state.configuracao.email}
                </div>

                

                <a href="/user/login">
                <div class="email">
                 
                    <i class="fa fa-home">
                      
                    </i> Portal Financeiro
                  
                </div>
                </a>
                </span>
			</div>
	</div>

<nav class="navbar navbar-expand-lg ">
    <a href="/" class="navbar-brand"><img  src={Logo} /></a>


    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText"
    aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
     <img class="imgtogglermenu" src="https://img.icons8.com/wired/50/000000/top-menu.png" />
    </button>

   


    <a class="mobile" target="_blank" href={"http://api.whatsapp.com/send?phone=55"+this.state.configuracao.whatsapp+"&text="+this.state.configuracao.whatsapptext}>
            <img src={Whatsapp} class="ico-whatsapp"/>
    </a>
    
    <div class="collapse navbar-collapse" id="navbarText">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item active">
          <a class="nav-link" href="/">Início
            <span class="sr-only">(current)</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" target="_blank" href="https://faculdadeolgamettig.edu.br/">Graduação</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/pos-graduacao">Pós-Graduação</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" target="_blank" href="https://faculdadeolgamettig.edu.br/a-olga-mettig/">Institucional</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/contato">Fale Conosco</a>
        </li>
        <li class="nav-item">

        <a class="nav-link btn btn-danger text-white" href="/user/inscreva">Inscreva-se</a>
        
        </li>
        <li class="nav-item whatsapplink whatsappa">
          <a target="_blank" href={"http://api.whatsapp.com/send?phone=55"+this.state.configuracao.whatsapp+"&text="+this.state.configuracao.whatsapptext}>
            <img src={Whatsapp} class="ico-whatsapp"/>
          </a>

        
        </li>

        

      </ul>
      
    </div>

  </nav>
  


      </React.Fragment>
       
    );
  }
}

export default withRouter(Index);


// WEBPACK FOOTER //
// ./src/pages/content/header.js